<template>
  <div class="blog-container">
    <Layout>
      <template #main>
        <div class="blog-main">
          <BlogView />
        </div>
      </template>
      <template #right>
        <div class="blog-right">
          <Sidebar @select="handleSelect" />
        </div>
      </template>
    </Layout>
  </div>
</template>
  
<script>
import Layout from '../../components/Layout';
import BlogView from './BlogView'
import Sidebar from './Sidebar';
export default {
  components: {
    Sidebar,
    Layout,
    BlogView
  },
  methods: {
    handleSelect(item) {
      console.log(item)
    }
  }
}
</script>
  
<style lang="less" scoped>
.blog-container {
  width: 100%;
  height: 100%;

  .blog-main {
    width: 100%;
  }

  .blog-right {
    overflow: hidden;
    width: 350px;
    height: 100%;
  }
}
</style>